import k from "../kaplayCtx";
import { getLeaderboard } from "../../shared/services/api";
import { getAuthManager } from "../../shared/systems/auth";
import {
  SCORE_FONT,
  MENU_TITLE_TEXT,
  MENU_TITLE_FONT_SIZE,
  MENU_TITLE_OFFSET_Y,
  MENU_SUBTITLE_TEXT,
  MENU_SUBTITLE_FONT_SIZE,
  MENU_SUBTITLE_OFFSET_Y,
  MENU_LEADERBOARD_FONT_SIZE,
  MENU_LEADERBOARD_START_Y,
  MENU_LEADERBOARD_ROW_SPACING,
  MENU_LEADERBOARD_MAX_ENTRIES,
  MENU_LEADERBOARD_NAME_MAX_LEN,
  MENU_LOADING_TEXT,
  MENU_EMPTY_TEXT,
  MENU_PLAY_TEXT,
  MENU_PLAY_FONT_SIZE,
  MENU_PLAY_OFFSET_Y,
  MENU_PLAY_DELAY,
} from "../../biai-game/config/constants";

function truncateName(name: string | null | undefined, maxLen: number): string {
  if (!name) return "Anónimo";
  return name.length > maxLen ? name.slice(0, maxLen) + ".." : name;
}

function padScore(score: number): string {
  return String(score).padStart(5, " ");
}

function createAuthOverlay() {
  const auth = getAuthManager();

  const container = document.createElement("div");
  container.style.cssText =
    "position:fixed;top:16px;right:16px;z-index:1000;display:flex;" +
    "align-items:center;gap:10px;font-family:sans-serif;";

  function render() {
    container.innerHTML = "";

    if (auth.isAuthenticated()) {
      const nameEl = document.createElement("span");
      nameEl.textContent = auth.getUserName();
      nameEl.style.cssText = "color:#fff;font-size:16px;";

      const logoutBtn = document.createElement("button");
      logoutBtn.textContent = "Salir";
      logoutBtn.style.cssText =
        "padding:6px 14px;font-size:14px;background:#333;color:#fff;" +
        "border:1px solid #666;border-radius:4px;cursor:pointer;";
      logoutBtn.addEventListener("click", async () => {
        await auth.logout();
        render();
      });

      container.append(nameEl, logoutBtn);
    } else {
      const loginBtn = document.createElement("button");
      loginBtn.textContent = "Iniciar Sesión";
      loginBtn.style.cssText =
        "padding:6px 14px;font-size:14px;background:#fff;color:#000;" +
        "border:none;border-radius:4px;cursor:pointer;";
      loginBtn.addEventListener("click", async () => {
        await auth.login();
        render();
      });

      container.appendChild(loginBtn);
    }
  }

  render();
  document.body.appendChild(container);
  return container;
}

export default function menu() {
  const cx = k.center().x;
  const cy = k.center().y;

  const authOverlay = createAuthOverlay();

  // Title
  k.add([
    k.text(MENU_TITLE_TEXT, { font: SCORE_FONT, size: MENU_TITLE_FONT_SIZE }),
    k.anchor("center"),
    k.pos(cx, cy + MENU_TITLE_OFFSET_Y),
    k.color(255, 255, 0),
  ]);

  // Subtitle
  k.add([
    k.text(MENU_SUBTITLE_TEXT, { font: SCORE_FONT, size: MENU_SUBTITLE_FONT_SIZE }),
    k.anchor("center"),
    k.pos(cx, cy + MENU_SUBTITLE_OFFSET_Y),
  ]);

  // Loading indicator
  const loadingText = k.add([
    k.text(MENU_LOADING_TEXT, { font: SCORE_FONT, size: MENU_LEADERBOARD_FONT_SIZE }),
    k.anchor("center"),
    k.pos(cx, cy),
  ]);

  // Fetch and render leaderboard
  let leftScene = false;
  getLeaderboard().then((scores) => {
    if (leftScene) return;
    loadingText.destroy();

    const entries = scores.slice(0, MENU_LEADERBOARD_MAX_ENTRIES);

    if (entries.length === 0) {
      k.add([
        k.text(MENU_EMPTY_TEXT, { font: SCORE_FONT, size: MENU_LEADERBOARD_FONT_SIZE }),
        k.anchor("center"),
        k.pos(cx, cy),
      ]);
      return;
    }

    entries.forEach((entry, i) => {
      const rank = `#${i + 1}`;
      const name = truncateName(entry.playerName, MENU_LEADERBOARD_NAME_MAX_LEN);
      const score = padScore(entry.score);
      const grade = entry.rank || "";
      const row = `${rank}  ${name}  ${score}  ${grade}`;

      k.add([
        k.text(row, { font: SCORE_FONT, size: MENU_LEADERBOARD_FONT_SIZE }),
        k.anchor("center"),
        k.pos(cx, cy + MENU_LEADERBOARD_START_Y + i * MENU_LEADERBOARD_ROW_SPACING),
      ]);
    });
  });

  // Play prompt (after short delay) — navigates to /biai-game
  k.wait(MENU_PLAY_DELAY, () => {
    k.add([
      k.text(MENU_PLAY_TEXT, { font: SCORE_FONT, size: MENU_PLAY_FONT_SIZE }),
      k.anchor("center"),
      k.pos(cx, cy + MENU_PLAY_OFFSET_Y),
    ]);

    k.onButtonPress("jump", () => {
      leftScene = true;
      authOverlay.remove();
      window.location.href = "/biai-game";
    });
  });
}
